import { IconButton } from "@mui/material";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import React from "react";
import * as style from "./CustomViewsMenu.module.scss";

interface MenuItem {
  id: string;
  label: string;
  shortLabel: string;
}

interface MenuGroup {
  title: string;
  items: MenuItem[];
}

interface CustomViewsMenuProps {
  isPanelOpen: boolean;
  groups: MenuGroup[];
  selectedItem: string;
  onItemClick: (itemId: string) => void;
  onPanelToggle: (isOpen: boolean) => void;
}

const CustomViewsMenu: React.FC<CustomViewsMenuProps> = ({
  isPanelOpen,
  groups,
  selectedItem,
  onItemClick,
  onPanelToggle,
}) => {
  const scssClass = style as any;
  return (
    <div
      className={scssClass.panel}
      style={{ width: isPanelOpen ? "240px" : "auto" }}
    >
      <div
        className={scssClass.title}
        style={{ justifyContent: isPanelOpen ? "space-between" : "center" }}
      >
        {isPanelOpen ? <div>Views</div> : <></>}
        <IconButton
          sx={{ transform: "rotate(90deg)", padding: "4px" }}
          onClick={() => onPanelToggle(!isPanelOpen)}
        >
          {isPanelOpen ? (
            <UnfoldLessIcon fontSize="small" />
          ) : (
            <UnfoldMoreIcon fontSize="small" />
          )}
        </IconButton>
      </div>

      <div className={scssClass.groupsContainer}>
        {groups.map((group) =>
          group.items.map((item, index) => (
            <div
              key={`${item.id}-${index}`}
              role="button"
              tabIndex={0}
              className={`${scssClass.options} ${selectedItem === item.id ? scssClass.active : ""}`}
              onClick={() => onItemClick(item.id)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onItemClick(item.id);
                }
              }}
              title={!isPanelOpen ? item.label : undefined}
            >
              {isPanelOpen ? item.label : item.shortLabel}
            </div>
          )),
        )}
      </div>
    </div>
  );
};

export default CustomViewsMenu;
